export const APP_BASE_PATH = '/par/'



// WEBPACK FOOTER //
// ./src/config/app.js